import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
class ActiveInactiveToggleButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.activeInactive';
        this.label = 'Active';
        this.tooltip = 'Toggle active in queue';
        this.toggledLabel = 'Inactive';
    }
    _isToggled() {
        return this.props.isActive;
    }
    _handleClick() {
        console.log('Toggle active/inactive');
        // Later, dispatch action
    }
}
function mapStateToProps(state) {
    // TODO: Get real state for isActive
    return {
        isActive: false
    };
}
export default translate(connect(mapStateToProps)(ActiveInactiveToggleButton));
